'use client';

export { default } from './TabScrollButton';
export { default as tabScrollButtonClasses } from './tabScrollButtonClasses';
export * from './tabScrollButtonClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/TabScrollButton/index.js
// module id = 541
// module chunks = 22